var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "20px",
    viewBox: "0 0 81 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hands") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-36",
    transform: "translate(-175.000000, -201.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92590196,158.318148 C7.6037364,161.262324 6.94265362,164.046326 6.94265362,166.670155 C6.94265362,169.293983 7.52320793,172.137984 8.68431655,175.202158 L5.90915699,178.313886 C4.06211769,176.300721 2.89439251,174.769133 2.40598145,173.719124 C0.422490949,169.454923 0.342282153,165.680086 0.383270864,163.513793 C0.439399053,160.547364 0.746416945,158.815482 1.30432454,158.318148 L8.92590196,158.318148 Z M79.9979668,158.318148 C80.5558744,158.815482 80.8628923,160.547364 80.9190205,163.513793 C80.9600092,165.680086 80.8798004,169.454923 78.8963099,173.719124 C78.4078988,174.769133 77.2401736,176.300721 75.3931343,178.313886 L75.3931343,178.313886 L72.6179748,175.202158 C73.7790834,172.137984 74.3596377,169.293983 74.3596377,166.670155 C74.3596377,164.046326 73.6985549,161.262324 72.3763894,158.318148 L72.3763894,158.318148 Z",
    id: "Hands"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/Hands.01ec9711f7d494d186d7ffc0472117bc.svg";
export { ForwardRef as ReactComponent };